import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

const sportRoutePrefixes = ['app.sports', 'app.home'];

/** Fetch sports translations if on a sports or home route */
export default defineNuxtRouteMiddleware(async to => {
	if (sportRoutePrefixes.some(prefix => to.name?.toString().startsWith(prefix))) {
		const languageStore = useLanguageStore();
		await languageStore.fetchSportsTranslation();
	}
});
